import { inject, Injectable } from "@angular/core";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faLock, faArrowLeft, faArrowUpRightFromSquare, faBars, faBellSlash, faBook, faBucket, faBuildingColumns, faBullhorn, faCalendar, faCalendarDays, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faChurch, faCircle, faCircleExclamation, faCircleInfo, faCircleXmark, faClipboard, faCloudArrowUp, faComment, faComments, faCopy, faCreditCard, faDollar, faDollarSign, faDownload, faDumbbell, faEdit, faEllipsisVertical, faEnvelope, faExclamationCircle, faExpand, faEye, faFileInvoice, faFileInvoiceDollar, faFileLines, faFilePdf, faFilePen, faFileSignature, faGavel, faGear, faGraduationCap, faHandHoldingHeart, faHandshake, faImage, faLocationDot, faMapLocation, faMinus, faMoneyBill, faMoon, faObjectsColumn, faPaperclip, faPaperPlane, faPencil, faPenToSquare, faPlaceOfWorship, faPlus, faQuestionCircle, faQrcode, faRightFromBracket, faRightLeft, faRoute, faSearch, faShare, faSpinner, faSuitcase, faSun, faSwap, faTasks, faToggleOff, faToggleOn, faTrash, faUniversalAccess, faUpload, faUser, faUserHeadset, faUserPen, faUserPlus, faUsers, faPlane, faWallet, faShieldCheck, faCheck, faTimes, faHandHoldingDollar, faCalendarStar, faAt } from "@fortawesome/pro-regular-svg-icons";
import { faArrowLeft as faArrowLeftSolid, faComments as faCommentsSolid, faPlane as faPlaneSolid, faFileLines as faFileLinesSolid, faUsers as faUsersSolid, faPlay as faPlaySolid, faXmark as faXmarkSolid, faRoute as faRouteSolid, faChurch as faChurchSolid, faDumbbell as faDumbbellSolid, faSuitcase as faSuitcaseSolid, faCircleQuestion as faCircleQuestionSolid, faCalendarDays as faCalendarDaysSolid, faCircleInfo as faCircleInfoSolid, faFileSignature as faFileSignatureSolid, faCreditCard as faCreditCardSolid, faDollarSign as faDollarSignSolid, faAsterisk, faPaperPlane as faPaperPlaneSolid, faClipboardList, faShareNodes, faLink, faMugSaucer, faFilePdf as faFilePdfSolid } from "@fortawesome/pro-solid-svg-icons";
import { faGoogle, faFacebook, faInstagram, faFacebookF, faYoutube, faApple, faXTwitter } from "@fortawesome/free-brands-svg-icons";

@Injectable({providedIn: 'root'})
export class IconService {

    library = inject(FaIconLibrary)

  constructor() {}

  registerIcons() {

    this.library.addIcons(
        faArrowLeftSolid,
        faChevronLeft,
        faChevronRight,
        faComments,
        faBullhorn,
        faTasks,
        faBucket,
        faCreditCard,
        faUserPen,
        faRightLeft,
        faXmarkSolid,
        faBars,
        faUser,
        faSearch,
        faRoute,
        faPaperclip,
        faPaperPlane,
        faCircle,
        faUpload,
        faDownload,
        faImage,
        faBuildingColumns,
        faArrowLeft,
        faBellSlash,
        faGraduationCap,
        faCheckCircle,
        faDollarSign,
        faUserPlus,
        faSwap,
        faObjectsColumn,
        faFilePen,
        faClipboard,
        faUsers,
        faFileInvoiceDollar,
        faChevronDown,
        faEdit,
        faUniversalAccess,
        faMoon,
        faRightFromBracket,
        faFileSignature,
        faDumbbell,
        faCalendarDays,
        faChurch,
        faFileLines,
        faQuestionCircle,
        faSuitcase,
        faRouteSolid,
        faChurchSolid,
        faDumbbellSolid,
        faSuitcaseSolid,
        faCircleQuestionSolid,
        faCalendarDaysSolid,
        faCircleInfoSolid,
        faFileSignatureSolid,
        faCreditCardSolid,
        faDollarSignSolid,
        faPlaySolid,
        faUsersSolid,
        faFileLinesSolid,
        faArrowUpRightFromSquare,
        faTasks,
        faUserHeadset,
        faCalendar,
        faGoogle,
        faFacebookF,
        faXTwitter,
        faInstagram,
        faYoutube,
        faApple,
        faCloudArrowUp,
        faMapLocation,
        faPlaceOfWorship,
        faLocationDot,
        faPlane,
        faShare,
        faComment,
        faEnvelope,
        faSun,
        faCircleInfo,
        faExclamationCircle,
        faWallet,
        faFileInvoice,
        faGear,
        faPencil,
        faTrash,
        faPlus,
        faMinus,
        faMoneyBill,
        faCopy,
        faEllipsisVertical,
        faEye,
        faAsterisk,
        faPaperPlane,
        faPaperPlaneSolid,
        faPlaneSolid,
        faPenToSquare,
        faGavel,
        faShieldCheck,
        faCheck,
        faTimes,
        faHandHoldingDollar,
        faCalendarStar,
        faHandshake,
        faBook,
        faCircleExclamation,
        faCircleXmark,
        faHandHoldingHeart,
        faDollar,
        faClipboardList,
        faShareNodes,
        faLink,
        faCommentsSolid,
        faSpinner,
        faFilePdf,
        faFilePdfSolid,
        faToggleOn,
        faToggleOff,
        faMugSaucer,
        faExpand,
        faLock,
        faAt,
        faQrcode
    )

  }
}